import { useQuery } from "@tanstack/react-query";
import { RuleBoxHistory } from "./RuleBoxHistory";
import { useTRPC } from "./trpc";

/**
 * A rule box's history as a page of its own, opened from the box list's History action: every
 * rebuild and what it changed, with a back button to the list.
 */
export function RuleBoxHistoryPage({ boxId, onBack }: { boxId: string; onBack: () => void }) {
  const trpc = useTRPC();
  const box = useQuery(trpc.boxes.get.queryOptions({ boxId }));

  return (
    <s-stack gap="base">
      <s-stack direction="inline">
        <s-button variant="tertiary" icon="arrow-left" onClick={onBack}>
          Back to your boxes
        </s-button>
      </s-stack>
      <s-heading>{box.data ? `History of ${box.data.name}` : "History"}</s-heading>
      <s-paragraph>
        Every time the box is rebuilt: the daily refresh, a price or stock change in your store,
        "Refresh now", or an edit. When a rebuild can't be done, the box shows sold out in your
        store until one can.
      </s-paragraph>
      <RuleBoxHistory boxId={boxId} />
    </s-stack>
  );
}
